import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { safeDecode } from "../../common/decoder";
import AddEditModule from "../../component/AddEditModuleComponent/AddEditModule";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "./editmodule.scss";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/loaderComponent/Loader";
import { AiOutlineSearch } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import { detailsmoduleListAction } from "../../actions/moduleListAction";
import {
  tutorialmoduleListAction,
  allcheckedtutorialAction,
} from "../../actions/trainingAction";
import { updateModuleAction } from "../../actions/moduleListAction";
import Paginations from "../../component/Pagination/PgmTextField";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { getVehicleAction } from "../../actions/getVehicle";
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from "@mui/material";
import NodataFound from "../../component/NodataFound";
import { Modal } from "react-bootstrap";
import PoppupThumbnail from "../../component/PoppupThumbnail";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import PopupConfirmation from "../../component/PopupConfirmation/PopupConfirmation";
import { Tooltip } from "@mui/material";
import { VehicleCategoryAction } from "../../actions/partcatelogueAction";
import { getVehiclelist_categoryAction } from "../../actions/getVehicle";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const EditModules = () => {
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [searchvalue, setSearchvalue] = useState("");
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };
  const handleCheckboxChange = (event) => {
    setSelectedCheckbox(event.target.value);
  };
  const [name, setTextName] = useState(0);
  function updateCharsters(e) {
    const text = document.getElementById("text2").value;
    setTextName(text?.length);
  }

  const handleCheckboxChanges = (event, id) => {
    if (event.target.checked) {
      if (selectedCheckboxes.length < 5) {
        setSelectedCheckboxes((prevSelected) => [...prevSelected, id]);
      } else {
        event.target.checked = false;
        NotificationManager.error(t('validationmsg.selectlimit'));
      }
    } else {
      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((selectedId) => selectedId !== id)
      );
    }
  };

  var tutorialpagination = 10;

  const [tutorialListData, settutorialList] = useState([]);

  const { id } = useParams();
  const decodeid = safeDecode(id);

  const [state, setDataState] = useState({
    name: "",
    training_ids: [],
    description: "",
    attachment: "",
    vehicle_category: ""
  });

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setDataState({
      ...state,
      [name]: value.replace(/^ +/gm, ""),
    });
    updateCharsters();
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [detailsmoduleviewList, setDetailsModuleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTutorialList, setIsLoadingTutorialList] = useState(false);
  const [startIndex, setStartIndex] = useState(1);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [vehicleMenu, setVehicleMenu] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [getVehicleList, setGetVehicleList] = useState([]);
  const files = ["Video", "PDF"];
  const handleFiletypeChange = (event) => {
    setFileName(event.target.value);
  };
  const handleVehicleMenuChange = (event) => {
    setVehicleMenu(event.target.value);
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    DetaiilsmoduleListData();
    tutorialData();
    handleChangeLanguage(language);
    VehicleCategoryListData();
    if (state.vehicle_category) {
      CategoryVehicleListData(state?.vehicle_category)
    }
  }, [state?.vehicle_category]);
  useEffect(() => {
    tutorialData();
  }, [page]);

  const [vehicleList, setVehicleList] = useState([]);
  async function VehicleCategoryListData() {
    setIsLoading(true);
    let response = await dispatch(VehicleCategoryAction());
    if (response == 200 || response != null) {
      setVehicleList(response.data.data.results);
    }
      setIsLoading(false);
  }

  const [getVehiclecatList, setGetVehiclecatList] = useState([]);
  const CategoryVehicleListData = async (id) => {
    setIsLoading(true);
    let response;
    if (!id) {
      setIsLoading(false);
      return;
    }
    response = await dispatch(getVehiclelist_categoryAction(id));
    if (response === 200 || response != null) {
      setGetVehiclecatList(response.data.data.results);
    }
    setIsLoading(false);
  };

  async function tutorialData() {
    const vehicleList = vehicleMenu.join(",");
    const fileType = fileName.join(",").toLowerCase();
    const newStartIndex = (page - 1) * tutorialpagination + 1;
    setStartIndex(newStartIndex);
    setIsLoadingTutorialList(true);
    let response = await dispatch(
      tutorialmoduleListAction(
        decodeid,
        page,
        fileType,
        vehicleList,
        searchvalue
      )
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response.data.data.count / tutorialpagination));
      settutorialList(response.data.data.results);
      setTextName(response.data.data.name?.length);
      setIsLoadingTutorialList(false);
    } else if (response === undefined) {
      setIsLoadingTutorialList(false);
    }
  }

  async function filterSearch() {
    setPage(1);
    const defaultpage = 1;
    const vehicleList = vehicleMenu.map((data) => {
      return data.id;
    });
    const fileType = fileName.map((data) => {
      return data.toLowerCase();
    });
    const newStartIndex = (page - 1) * tutorialpagination + 1;
    setStartIndex(newStartIndex);
    setIsLoadingTutorialList(true);
    let response = await dispatch(
      tutorialmoduleListAction(
        decodeid,
        defaultpage,
        fileType,
        vehicleList,
        searchvalue
      )
    );
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response.data.data.count / tutorialpagination));
      settutorialList(response.data.data.results);
      setTextName(response.data.data.name?.length);
      setIsLoadingTutorialList(false);
    } else if (response === undefined) {
      setIsLoadingTutorialList(false);
    }
  }

  async function DetaiilsmoduleListData() {
    const newStartIndex = (page - 1) * tutorialpagination + 1;
    setStartIndex(newStartIndex);
    setIsLoading(true);
    let response = await dispatch(detailsmoduleListAction(decodeid));
    if (response.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response.data.data.count / tutorialpagination));
      setDetailsModuleList(response.data.data);
      const trainingList = response.data.data.training_list;
      const idsArray = trainingList.map((item) => item.id);
      setSelectedCheckboxes(idsArray);
      setDataState({
        ...state,
        name: response.data.data.name,
        training_ids: [],
        description: response.data.data.description,
        attachment: response.data.data.attachment,
      });
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }

  const onupdateModule = async () => {
    setIsLoading(true);
    let apiReq = new FormData();
    apiReq.append("name", state.name);
    apiReq.append("description", state.description);
    selectedCheckboxes.forEach((value, index) => {
      apiReq.append(`training_ids`, value);
    });
    let response = await dispatch(updateModuleAction(decodeid, apiReq));
    if (response?.status === HTTP_STATUS.CREATED) {
      NotificationManager.success(response.data.message);
      DetaiilsmoduleListData();
      tutorialData();
      window.scroll(0, 0);
      setIsLoading(false);
    }
    navigate("/productTraining");
  };

  const [showThumbnail,setShowThumbnail] = useState(false);
  const [attachmenturl,setAttachmenturl] = useState("");
  const [attachmentType,setAttachmentType] = useState("");

  const OpenThumbnailPopup  = (attachment,attachment_type) =>{
    if(attachment_type=== "pdf"){
      window.open(attachment, '_blank');
      NotificationManager.success("Pdf downloaded successfully !");
    }
    else{
      setShowThumbnail(true);
      setAttachmenturl(attachment);
      setAttachmentType(attachment_type);
    }
   
  } 

  const CloseThumbnailPopup  = () =>{
    setShowThumbnail(false);
  }

  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleEditModulePopupCloseButtons = () => {
    if(
      state?.name === "" ||
      state?.description === "" ||
      selectedCheckboxes?.length === 0
    ){
      navigate("/producttraining")
    }
    else{
      setConfirmationPopupshow(true);
    }
  };
  const closeModuleConfirmationPopup = () => {
    setConfirmationPopupshow(false);
  };
  useEffect(() => {
    if(!searchvalue){
      tutorialData();
    }
    }, [searchvalue])
  return (
    <div className="EditModule_containers">
      <div className="AddEditModule_container">
        <div className="AddEditModulecontent">
          <div className="header_border">
          <p className="pgm-list-header-text">TVS &gt; {t('training_module.trainingmodule')}  &gt; {t('add_module.editModule')}</p>
          </div>
          <div className="AddEditModule_panel">
            <div className="panel-all">
            {t('add_module.editModule')}
              <button
                className="AddEditModule_Close"
                onClick={handleEditModulePopupCloseButtons}
              >
                {t('add_module.close')}
              </button>
            </div>
          </div>
          <div className="hero-section">
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <div className="title-input">
                  <div class="input-wrapper">
                    <label className="required" for="first">{t('add_module.moduleName')}</label>
                    <div className="">
                      <input
                        type="text"
                        name="name"
                        defaultValue={state.name}
                        className="text-field"
                        placeholder={t('add_module.moduleNamePlaceholder')}
                        onInput={handleChange}
                        rows={10}
                        cols={50}
                        id="text2"
                        maxLength={100}
                      />
                      <p className="content-titless montserrat-font">
                      {(state?.name)?.length || 0}/100
                      </p>
                    </div>
                  </div>
                  <div class="input-wrapper">
                    <label className="required" for="first">{t('add_module.description')}</label>
                    <div className="">
                      <input
                        type="text"
                        name="description"
                        value={state.description}
                        className="text-field"
                        placeholder={t('add_module.description')}
                        onChange={handleChange}
                        rows={10}
                        cols={50}
                        maxLength={500}
                      />
                      <p className='add-modules-titles'>{(state?.description)?.length || 0}/500</p>
                    </div>
                  </div>
                </div>
                <div className="panel-text required">
                {t('add_module.maxContentLimit')}
                  {selectedCheckboxes.length}/5
                </div>
                <div className="modulePanel_checkbox">
                  <div className="checkbox_contain">
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">
                          <FormControl className="module-form-select">
                            <label className="select_label">
                            {t('add_module.selectFileTypeLabel')}
                            </label>
                            <Select
                              className="module-select"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={fileName}
                              onChange={handleFiletypeChange}
                              inputProps={{ className: "module_input" }}
                              renderValue={(selected) => selected.join(", ")}
                            >
                              {files.map((data) => (
                                <MenuItem key={data} value={data}>
                                  <Checkbox
                                    checked={fileName?.indexOf(data) > -1}
                                  />
                                  <ListItemText primary={data} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">
                        <select
                                name="vehicle_category"
                                value={state.vehicle_category}
                                onChange={handleChange}
                                className="category_select"
                                required
                              >
                                <option value="">{t('tutorialtraining.vehiclecategory')}</option>
                                {vehicleList.map((data, i) => (
                                  <option value={data.id}>{data.name}</option>
                                ))}
                              </select>
                        </div>
                      </div>
                    </div>
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">
                          <FormControl className="module-form-select">
                            <label className="select_label">
                            {t('add_module.selectVehicle')}
                            </label>
                            <Select
                              className="module-select"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={vehicleMenu}
                              onChange={handleVehicleMenuChange}
                              inputProps={{ className: "module_input" }}
                              renderValue={(selected) => {
                                const selectedRoleNames = selected.map(
                                  (data) => data.name
                                );
                                return selectedRoleNames.join(", ");
                              }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: "200px",
                                  },
                                },
                              }}
                            >
                              {state.vehicle_category && getVehiclecatList.map((data) => (
                                <MenuItem key={data.id} value={data}>
                                  <Checkbox
                                    checked={vehicleMenu.some(
                                      (item) => item.id === data.id
                                    )}
                                  />
                                  <ListItemText
                                    value={data.id}
                                    primary={data.name}
                                  />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="search-box">
                    <input
                      placeholder={t('add_module.search')}
                      class="search-input"
                      value={searchvalue}
                      onChange={(e) => setSearchvalue(e.target.value)}
                    />
                    <div className="search-icon">
                      <button onClick={filterSearch}>{t('add_module.search')}</button>
                    </div>
                  </div>
                </div>
                <div className="table-content">
                  {isLoadingTutorialList ? (
                    <Loader />
                  ) : (
                    <div className="tabledata">
                      {tutorialListData?.length > 0 ? (
                        <table className="table">
                          <tr>
                            <th className="tablesth"></th>
                            <th className="tablesth"> {t('add_module.thumbnail')}</th>
                            <th className="tablesth"> {t('add_module.tutorialTitle')}</th>
                            <th className="tablesth">{t('add_module.description')}</th>
                            <th className="tablesth">{t('add_module.fileTypeLabel')}</th>
                            <th className="tablesth"></th>
                            <th className="tablesth"></th>
                          </tr>
                          {tutorialListData?.map((data, i) => (
                            <tbody>
                              <tr key={i}>
                                <td className="tabletd">
                                  <input
                                    className="input_checkbox"
                                    type="checkbox"
                                    name={data.id}
                                    value={data.id}
                                    checked={selectedCheckboxes.includes(
                                      data.id
                                    )}
                                    onChange={(e) =>
                                      handleCheckboxChanges(e, data.id)
                                    }
                                  />
                                </td>
                                <td className="tabletd" onClick={()=>OpenThumbnailPopup(data.attachment,data?.attachment_type.toLowerCase())}>
                                  <img
                                    height="77.77px"
                                    width="126px"
                                    src={data?.attachment_type.toLowerCase() === "pdf" ? Image_Url.PDF_THUMBNAIL : data?.attachment_type.toLowerCase() === "video" || data?.attachment_type.toLowerCase() === "scorm"
                                    ? (data.video_thumbnail === null ? Image_Url.VIDEO_THUMBNAIL : data.video_thumbnail) : Image_Url.PDF_THUMBNAIL
                                    }
                                  />
                                </td>
                                <td className="tabletd">{data.title} </td>
                                <td className="tabletd"><Tooltip arrow title={String(data?.description).length>100?String(data.description):""}><div style={{padding:0,marginBottom:"-20px"}}>{String(data.description).substring(0,100) + (String(data?.description).length>100?"...":"")}</div></Tooltip> </td>
                                <td className="tabletd">
                                  {data.attachment_type}
                                </td>
                                <td className="tabletd"></td>
                                <td className="tabletd_view"></td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      ) : (
                        <NodataFound />
                      )}
                    </div>
                  )}
                  <div className="edit-Module-pagination">
                    <Paginations
                      count={count}
                      page={page}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
                <div className="AddEditmodel_panel">
                  <div className="panel-all">
                    {hasPermission(PERMISSIONS.CAN_UPDATE_TRAINING_MODULE) && (
                      <button
                        className="AddEditmodel_create"
                        onClick={handleConfirmationPopup}
                        disabled={
                        state?.name === ""||
                        state?.description === "" ||
                        selectedCheckboxes?.length === 0
                        }
                      >
                        {t('add_module.updateModuleButton')}
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
             <Modal
            className="expertise-modal montserrat-font"
            show={showThumbnail}
            onHide={CloseThumbnailPopup}
          >
            <Modal.Body className="p-0">
                <PoppupThumbnail
                CloseThumbnailPopup ={CloseThumbnailPopup}
                attachmenturl={attachmenturl}
                attachmentType={attachmentType}
                />
            </Modal.Body>
          </Modal>
            <div className="footer_div">
              <Footer />
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={closeModuleConfirmationPopup}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={closeModuleConfirmationPopup}
              onSaveClick={onupdateModule}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditModules;
